function CompaignHeadings({ campaignheadings, company, text_class }) {
  // Check if there are any valid headings with either title or text
  const validHeadings = campaignheadings?.filter(
    (heading) => heading.field_title || heading.field_text,
  );

  if (!validHeadings?.length) return null;

  return (
    <div
      style={{
        background: company?.brand_color || "#000",
        color: company?.brand_text_color || "#fff",
      }}
      className="rounded-xl shadow-xl mb-12"
    >
      <div className="p-12">
        <div className="max-w-6xl mx-auto">
          <div
            className={`grid gap-8 ${validHeadings.length === 1 ? "grid-cols-1" : "grid-cols-1 md:grid-cols-2"}`}
          >
            {validHeadings.map((section, index) => (
              <CampaignHeaderElements
                key={index}
                {...section}
                text_class={text_class}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CompaignHeadings;

function CampaignHeaderElements({ field_title, field_text, text_class }) {
  if (!field_title && !field_text) return null;

  return (
    <div>
      {field_title && (
        <h3 className={`text-xl font-semibold mb-3 ${text_class}`}>
          {field_title}
        </h3>
      )}
      {field_text && (
        <div
          className={`leading-relaxed text-sm ${text_class}`}
          dangerouslySetInnerHTML={{ __html: field_text }}
        />
      )}
    </div>
  );
}
